// extracted by mini-css-extract-plugin
module.exports = {"container":"teamMember_container__HIkb2","image":"teamMember_image__HW_e4","linkWrapper":"teamMember_linkWrapper__QmJ28"};